import { useAppSelector } from '@/hooks/storeHook';
import Backdrop from '@mui/material/Backdrop';

const GlobalBackdrop = () => {
  const isOpen = useAppSelector((state) => state.ui.backdropOpen);
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
      open={isOpen}
      data-testid="global-backdrop"
    />
  );
};

export default GlobalBackdrop;
